// eslint-disable-next-line import/no-cycle
import store from '@client/store';
import {Logger, Category} from '@simpleinvest/front-end-logger';
import {Route, NavigationGuardNext} from 'vue-router';

const logger = new Logger({
  category: Category.Cms,
  fileName: 'cms.js',
});

const cms = async (to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
  // opt in for now
  if (!to.name) {
    next();

    return;
  }

  // TODO: Simplify to `!to.meta.CMS` in the if above?
  const match = to.matched.find((i) => i.name === to.name);

  if (match && !match.meta.CMS) {
    next();

    return;
  }

  try {
    await store.dispatch('CMS/findPage', to.name);
  } catch (error) {
    logger.addBreadcrumb({
      callingFuncName: 'cms',
      message: 'Failed to get content from CMS.',
    });

    logger.logException({error});
  } finally {
    // eslint-disable-next-line callback-return
    next();
  }
};

export default cms;
